import { ETabGroup, ETypeLink, ETypeLinkRecruit } from 'common';
import configs from 'config';
import { IResNotice } from 'data/notification/useNotice';

const getIdCommentParent = (item: IResNotice) => {
  if (!item?.comment) {
    return;
  }
  const comment = JSON.parse(item?.comment);
  return comment?.grand_id || comment?.parent_id || comment?.id;
};
const getIdScrollTo = (item: IResNotice) => {
  if (!item?.comment) {
    return;
  }
  const comment = JSON.parse(item?.comment);
  return comment?.id || comment?.parent_id || comment?.grand_id;
};

export const getUrlNotificationToWiki = (type: number, notification: IResNotice) => {
  const WIKI_URL = configs.DOMAIN_AMS_WIKI;
  if (type === ETypeLink.DETAIL_POST || type === ETypeLink.DETAIL_REPORT) {
    if (notification?.group_id) {
      return WIKI_URL + `/group/detail-group/${notification.group_id}/${notification.post_id}`;
    }
    return WIKI_URL + `/home/detail-post/${notification.post_id}`;
  }
  if (type === ETypeLink.DETAIL_COMMENT) {
    if (notification?.group_id) {
      return (
        WIKI_URL +
        `/group/detail-group/${notification.group_id}/${notification.post_id}?idNotice=${getIdCommentParent(
          notification
        )}&idScroll=${getIdScrollTo(notification)}`
      );
    }
    return (
      WIKI_URL +
      `/home/detail-post/${notification.post_id}?idNotice=${getIdCommentParent(notification)}&idScroll=${getIdScrollTo(
        notification
      )}`
    );
  }
  if (type === ETypeLink.DETAIL_POST_GROUP) {
    return WIKI_URL + `/group/classification/${notification?.group_id}`;
  }
  if (type === ETypeLink.SERIES) {
    if (notification?.group_id) {
      return WIKI_URL + `/group/list-series/${notification?.group_id}/${notification?.series_id}`;
    }
    return WIKI_URL + `/home/list-series/${notification?.series_id}`;
  }
  if (type === ETypeLink.GROUP_APPROVE_MEMBER) {
    if (notification?.group_id) {
      return WIKI_URL + `/group/user-manage-group/${notification.group_id}?tab=${ETabGroup.REQUEST_JOIN}`;
    }
  }
  if (type === ETypeLink.GROUP_APPROVE_POST) {
    if (notification?.group_id) {
      return WIKI_URL + `/group/user-manage-group/${notification.group_id}?tab=${ETabGroup.LIST_WAITING}`;
    }
  }
  if (type === ETypeLink.GROUP_LIST_REPORT) {
    if (notification?.group_id) {
      return WIKI_URL + `/group/user-manage-group/${notification.group_id}?tab=${ETabGroup.LIST_REPORT}`;
    }
  }
};

export const getUrlNotificationToRecruit = (type: number, notification: IResNotice) => {
  let detail = JSON.parse(notification?.detail);
  if (!detail) detail = {};
  const { interview_date, interview_id, job_id, order_id, candidate_id, apply_id, kpi_id } = detail;
  switch (type) {
    case ETypeLinkRecruit.DETAIL_APPLY_INTERVIEW_LEADER:
      return `/admin/candidate-detail/${candidate_id}/apply-detail/${apply_id}`;
    case ETypeLinkRecruit.DETAIL_INTERVIEW_SCHEDULE:
      return `/admin/interview-schedule/${interview_date}/${interview_id}`;
    case ETypeLinkRecruit.LIST_INTERVIEW_SCHEDULE:
      return `/admin/interview-schedule`;
    case ETypeLinkRecruit.DETAIL_ORDER_LEADER:
      return `/admin/manager-order/${order_id}`;
    case ETypeLinkRecruit.DETAIL_JOB:
      return `/admin/manager-job/${job_id}`;
    case ETypeLinkRecruit.DETAIL_ORDER_HR:
      return `/admin/manager-order/${order_id}`;
    case ETypeLinkRecruit.DETAIL_APPLY_INTERVIEW_HR:
      return `/admin/candidate-detail/${candidate_id}/apply-detail/${apply_id}`;
    case ETypeLinkRecruit.DETAIL_APPLY_TEST_HR:
      return `/admin/candidate-detail/${candidate_id}/apply-detail/${apply_id}/test`;
    case ETypeLinkRecruit.LIST_KPI:
      return `/admin/manager-kpi`;
    case ETypeLinkRecruit.DETAIL_KPI:
      return `/admin/manager-kpi/${kpi_id}`;
    case ETypeLinkRecruit.LIST_REF_BONUS:
      return `/admin/list-referral-bonus`;
    case ETypeLinkRecruit.LIST_COST_RECRUIT:
      return `/admin/list-cost-recruit`;
    case ETypeLinkRecruit.DETAIL_CANDIDATE_HR:
      return `/admin/candidate-detail/${candidate_id}`;
    default:
      return '';
  }
};

export const getUrlNotificationToProject = (type: number, notification: IResNotice) => {
  const detail = notification?.detail;
  if (detail.length) {
    const detailPath = JSON.parse(detail);
    if (detailPath.path.length) return detailPath.path;
  }

  return `/projects/detail/${notification?.project_id}`;
};
